import { apiClient, handleApiRequest } from './client'
import type { CancellationAdminResponse } from '@/types/admin5'

export const cancellationsApi = {
  listAllStornos: () =>
    handleApiRequest<CancellationAdminResponse[]>(
      apiClient.get('/api/v1/cancellation-requests?scope=school'),
    ),

  adminOverride: (cancellationId: string, action: 'accept' | 'decline', itemId?: string) =>
    handleApiRequest<{ message: string; success: boolean }>(
      apiClient.post(`/api/v1/cancellation-requests/${cancellationId}/admin-override`, {
        action,
        item_id: itemId,
      }),
    ),
}
